export default "__VITE_ASSET__15f89b7c__"